import api from "./";

export default {

	/**
	 * Get stats of store
	 * @param store
	 * @param params
	 */
	getStats(store, params) {
		return api
			.get(`/stores/${store}/stats`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Get list of stores
	 * @param params
	 */
	get(params) {
		return api
			.get(`/stores`, {
				params: params,
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Create store
	 * @param data
	 */
	create(data) {
		return api.post(`/stores`, data).then((response) => {
			return response.data;
		});
	},

	/**
	 * Show store
	 * @param storeId
	 * @param params
	 */
	show(storeId, params) {
		return api
			.get(`/stores/${storeId}`, {
				params: params
			})
			.then((response) => {
				return response.data;
			});
	},

	/**
	 * Update store
	 * @param storeId
	 * @param data
	 */
	update(storeId, data) {
		return api.put(`/stores/${storeId}`, data).then((response) => {
			return response.data;
		});
	},

	/**
	 * Delete store
	 * @param storeId
	 */
	delete(storeId) {
		return api.delete(`/stores/${storeId}`).then((response) => {
			return response.data;
		});
	}

}
